import React from 'react';

const LoungeResults = () => {
  return (
    <div id="App"></div>
  );
};

export default LoungeResults;
